import script from "./AiClearButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiClearButton.vue?vue&type=script&lang=ts&setup=true"

import "./AiClearButton.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__